module.exports = __webpack_public_path__ + "static/media/home_zz3.ff98f9a0.png";